<template>
    <div class="rounded-lg bg-white shadow">
        <slot />
    </div>
</template>
